module.exports = __webpack_public_path__ + "static/media/3DPPA5.3c8087e5.jpg";